import React, { useMemo } from "react";
import moment from "moment";
import { useDCContext, useAuthContext } from "@src/context";
import ManagerHooks from "@src/context/hooks/managerHooks";
import OverviewHeader from "@src/components/layout/OverviewHeader";
import Loader from "@src/components/atoms/Loader";
import Icon from "@src/components/atoms/Icon";
import { AppUtils } from "@src/utils";
import { useManagerContext } from "../../../context/managerContext";

/** Manager version of "OverviewHeader" */
const ManagerOverviewHeader = (props) => {
  const { newHeader = false } = props;
  const { profile } = useManagerContext();
  const customer = profile.customer;
  const auth = useAuthContext();
  const dc = useDCContext();

  //Latest Data Received
  const {
    data: { latestDataReceivedTimestamp } = {},
    isPending: latestDataReceivedTimestampPending,
    error: latestDataReceivedError,
  } = ManagerHooks.useGetLatestDataReceived(auth.activeRole);

  const greeting = useMemo(
    () =>
      dc.getDynamicReplacement("fuel_manager__overview__greeting", {
        FIRST_NAME: auth.user.firstname,
        LAST_NAME: auth.user.lastname,
        FIRSTNAME: auth.user.firstname,
        LASTNAME: auth.user.lastname,
      }),
    [dc, auth.user.firstname, auth.user.lastname],
  );
  const subTitle = dc.getDynamicReplacement(
    "fuel_manager__overview__latest_data_received",
    {},
    "Latest data received:",
  );
  const latestDataReceived = latestDataReceivedTimestampPending ? (
    <Loader size="xs" inline />
  ) : latestDataReceivedError != null ? (
    <Icon name="brokenChains" size="sm" inline />
  ) : (
    moment.utc(latestDataReceivedTimestamp).format("Do MMM YYYY")
  );

  const newHeaderGreeting = dc.getDynamicReplacement(
    "manager_module__overview__greeting",
    {},
  );
  const explanation = (
    <div>
      This fuel and financial overview corrects for fixed effects on fuel
      consumption and contains <span className="font-bold">only</span> results
      that meet a high level of statistical significance. Look out for this
      symbol
      <div className="inline-flex px-2">
        <Icon
          name="statisticalSignificance"
          size="sm"
          backgroundColor="transparent"
          padding={false}
          centered={false}
          // className="mx-1.5"
        />
      </div>
      which indicates a reliable result. Results with this symbol
      <div className="inline-flex px-2">
        <Icon
          name="notStatisticallySignificant"
          size="sm"
          backgroundColor="transparent"
          padding={false}
          centered={false}
          // className="mx-1.5"
        />
      </div>
      should not be interpreted as reliable estimates of Signol's impact.
    </div>
  );
  return (
    <>
      {newHeader ? (
        <div className="w-full min-h-36 relative overflow-hidden flex bg-primary-300 text-primary-900 justify-between items-center px-6">
          <div className="flex flex-col w-4/5">
            <div className="text-4xl font-extrabold">{newHeaderGreeting}</div>
            <div className="mt-2">{explanation}</div>
          </div>
        </div>
      ) : (
        <OverviewHeader
          checkDynamicContentExists={dc.existsDynamicReplacements}
          customerCode={customer.customerCode}
          dataMessage={
            <>
              {subTitle} {latestDataReceived}
            </>
          }
          getDynamicContent={dc.getDynamicReplacement}
          greeting={greeting}
        />
      )}
    </>
  );
};

export const managerOverviewHeaderControls = {};
ManagerOverviewHeader.propTypes = AppUtils.getPropTypeFromControls(
  managerOverviewHeaderControls,
);
export default ManagerOverviewHeader;
